import styled from 'styled-components'

export default styled.div`
	text-align: left;
	margin-left: auto;
	margin-right: ${({ marginRight }) => marginRight || 'auto'};
	position: relative;
	width: ${({ selectWidth }) => selectWidth || '100%'};
`
